/**
 * Ensure DATACORD_VERSION is globally available
 * This utility provides a standardized way to work with application versioning
 */

// TypeScript interface for version object
export interface DatacordVersion {
  version: string;
}

// Declare global interface for TypeScript
declare global {
  interface Window {
    DATACORD_VERSION: DatacordVersion | string;
  }
}

// The actual version from package.json or default to current date
const DEFAULT_VERSION = 
  typeof process !== 'undefined' && process.env?.npm_package_version || 
  '2024-04-12';

/**
 * Initialize the version in the window object
 * This ensures window.DATACORD_VERSION is always properly defined
 */
export function initializeVersion(): string {
  // Make sure DATACORD_VERSION exists and has the right format
  window.DATACORD_VERSION = window.DATACORD_VERSION || { version: DEFAULT_VERSION };
  
  // In case DATACORD_VERSION exists but doesn't have a version property
  if (typeof window.DATACORD_VERSION === 'object' && !window.DATACORD_VERSION.version) {
    window.DATACORD_VERSION.version = DEFAULT_VERSION;
  }
  
  return getVersion();
}

/**
 * Get the current application version
 * @returns The current version string
 */
export function getVersion(): string {
  if (typeof window !== 'undefined' && window.DATACORD_VERSION) {
    if (typeof window.DATACORD_VERSION === 'object' && window.DATACORD_VERSION.version) {
      return window.DATACORD_VERSION.version;
    } else if (typeof window.DATACORD_VERSION === 'string') {
      return window.DATACORD_VERSION;
    }
  }
  
  return DEFAULT_VERSION;
}

// Initialize on import
initializeVersion();

export default {
  getVersion,
  initializeVersion
}; 